import React, { useState } from "react";
import { Autocomplete, Grid, TextField, FormControlLabel, Checkbox } from "@mui/material";
import { AloveDialog, DialogType } from "components/alove/AloveDialog";
import { useMaterialUIController, setCurrentDialog, addAlert } from "context";
import { addNewTranslationLangDO } from "utils/translateUtils";
import { T } from "components/alove/Translator";
import { Language } from "models/content/Language";
import languages from "./languaesList.json";
import { DropdownButton } from "components/alove/DropDownButton";

const MDInput = require("components/MDInput").default;

interface AddNewLanguageModalProps {
  refresh: () => void;
}

interface LanguageOption {
  code: string;
  name: string;
  flag: string;
}

export const AddNewLanguageModal: React.FC<AddNewLanguageModalProps> = ({
  refresh,
}) => {
  const [controller, dispatch] = useMaterialUIController();
  const [selectedLanguage, setSelectedLanguage] = useState<LanguageOption | null>(null);
  const [localName, setLocalName] = useState("");
  const [rtl, setRtl] = useState(false);

  const handleConfirm = async () => {
    if (!selectedLanguage) return;

    try {
      const data = {
        code: selectedLanguage.code,
        name: selectedLanguage.name,
        localName: localName || selectedLanguage.name,
        flag: selectedLanguage.flag,
        rtl: rtl,
      };

      await addNewTranslationLangDO(data);
      addAlert(dispatch, "Language added successfully");
      refresh();
      setSelectedLanguage(null);
      setLocalName("");
      setRtl(false);
    } catch (error) {
      addAlert(dispatch, "Failed to add language");
    }
  };

  const isValid = Boolean(selectedLanguage && localName.trim() !== "");

  return (
    <AloveDialog
      dialogType={DialogType.AddNewLanguage}
      dialogTitle="Add New Language"
      dialogConfirm="Add"
      handleConfirm={handleConfirm}
      valid={isValid}
      width="500px"
    >
      <Grid container spacing={2}>
        <Grid size={12}>
          <Autocomplete
            options={languages}
            getOptionLabel={(option) => `${option.flag} ${option.name} (${option.code})`}
            value={selectedLanguage}
            onChange={(event, newValue) => {
              setSelectedLanguage(newValue);
              if (newValue && !localName) {
                setLocalName(newValue.name);
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Language"
                required
                fullWidth
              />
            )}
          />
        </Grid>
        <Grid size={12}>
          <MDInput
            label="Local Name"
            value={localName}
            onChange={(e) => setLocalName(e.target.value)}
            required
            fullWidth
          />
        </Grid>
        
        <Grid size={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={rtl}
                onChange={(e) => setRtl(e.target.checked)}
                color="primary"
              />
            }
            label="RTL (Right-to-Left)"
          />
        </Grid>
      </Grid>
    </AloveDialog>
  );
};

export default AddNewLanguageModal; 